import { type Property } from 'csstype';
import styled from 'styled-components';

export interface ITableCellProps {
  readonly $alignItems?: Property.AlignItems;
  readonly $isCompact?: boolean;
}

export const TableButtonActionsCellContainer = styled.div<ITableCellProps>`
  align-items: ${({ $alignItems }) => $alignItems ?? 'flex-start'};
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  padding: 0.5rem;
  gap: 8px;

  ${({ $isCompact = false }) =>
    $isCompact &&
    `
    gap: 4px;

    button {
      min-width: auto;
      padding: 0.5rem;

      svg {
        width: 1rem;
        height: 1rem;
      }
    }
  `}
`;
